import { Button, ButtonsGroup, Price } from "#/atoms";
import { FC, memo, useCallback } from "react";
import { FONT_SIZE, FONT_WEIGHT } from "@/theme";

import { ChoiceModal } from "../Modais/Choice";
import CloneIcon from "@/assets/icons/Clone";
import { ConfirmModal } from "../Modais/Confirm";
import CrossIcon from "@/assets/icons/Cross";
import EditIcon from "@/assets/icons/Edit";
import { EditPackageModal } from "../Modais/EditPackage";
import HideIcon from "@/assets/icons/Hide";
import { OrderTemplateProps } from "./Package.interface";
import ShowIcon from "@/assets/icons/Show";
import { StyledOrderTemplate } from "./Package.styled";
import { useModal } from "@/hooks";

const OrderTemplate: FC<OrderTemplateProps> = ({onClick, useSimpleSelect, 
  onActivate, onClone, onDeactivate, onDelete, onSet, ...orderTemplate  }) => {
  
  const { showModal: showChoiceModal, onCloseModal: onCloseChoiceModal, onOpenModal: onOpenChoiceModal } = useModal(); 
  const { showModal: showDeleteModal, onCloseModal: onCloseDeleteModal, onOpenModal: onOpenDeleteModal } = useModal(); 
  const { showModal: showEditModal, onCloseModal: onCloseEditModal, onOpenModal: onOpenEditModal } = useModal(); 

  const handleOrderTemplateClick = useCallback(() => {
    if (onClick) {
      onClick(orderTemplate.id)
    }
  }, [onClick, orderTemplate.id]);

  const handleOrderTemplateRowClick = useCallback(() => {
    useSimpleSelect && handleOrderTemplateClick();
  }, [useSimpleSelect]);

  const canEdit = orderTemplate.customerId || orderTemplate.hip;
  const canChoose = !orderTemplate.dea;

  return (
    <>
      <StyledOrderTemplate  onClick={handleOrderTemplateRowClick} style={ orderTemplate.customerId || useSimpleSelect ? {} : { color: '#600038', fontWeight: 'bold'   }}>
        <div style={ orderTemplate.dea ? { opacity: 0.55 } : { }} >{orderTemplate.description}</div>
        <div style={{ marginLeft: 'auto', maxWidth: '600px', opacity: orderTemplate.dea ? '0.55' : '1' }}>
          {orderTemplate.services.reduce((acc: string, cur) => { return cur.checked ? (acc ? acc + ", " + cur.name : cur.name) : acc;  }, '')}
        </div>
        <Price amount={orderTemplate.price} currency="GBP" fontSize={FONT_SIZE.LG} fontWeight={FONT_WEIGHT.SEMIBOLD} showVat />
        {!useSimpleSelect && <ButtonsGroup>
          {canChoose && <Button onClick={handleOrderTemplateClick}>Choose</Button>}
          {canEdit && (
            <>
              <Button actionType="icon" title="Edit" onClick={onOpenEditModal}>
                <EditIcon />
              </Button>
              <Button actionType="icon" title="Delete" onClick={onOpenDeleteModal}>
                <CrossIcon />
              </Button> 
            </>
          )}
          {!canChoose ? (
            <Button actionType="icon" title="Show" onClick={() => onActivate?.(orderTemplate.id, orderTemplate.customerId)}>
              <ShowIcon />
            </Button>
          ) : (
            <Button actionType="icon" title="Hide" onClick={onOpenChoiceModal}>
              <HideIcon />
            </Button>
          )}
          {!orderTemplate.customerId && <Button actionType="icon" title="Clone" onClick={() => onClone?.(orderTemplate.id)}>
            <CloneIcon />
          </Button>}
        </ButtonsGroup> }
      </StyledOrderTemplate>
      {showChoiceModal && <ChoiceModal 
        choice1Text="Hide For Customer"
        choice2Text="Hide Globally"
        description="You can hide a package globally or for current customer only."
        onChoice1={() => onDeactivate?.(orderTemplate.id, orderTemplate.customerId )}
        onChoice2={() => onDeactivate?.(orderTemplate.id)}
        onClose={onCloseChoiceModal}
        title="Choose deactivation type"
        />
      }
      {showDeleteModal   && <ConfirmModal 
        description="Are you sure you want to delete this package?"
        onConfirm={() => onDelete?.(orderTemplate.id)}
        onClose={onCloseDeleteModal}
        showCancel={true}
        title="Confirm delete package"
        />
      }
      {showEditModal   && <EditPackageModal
        loading={false}
        orderTemplate={orderTemplate} 
        onClose={onCloseEditModal}
        onSaveTemplate={(template) => { onSet?.(template); onCloseEditModal() }}
        />
      }
    </>
  );
}

export default memo(OrderTemplate);
